import React, { useEffect, useRef, useState } from "react";
import styles from '../styles/studentservices.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomImage from "./CustomImage"; 
import fetchUtil from "../utils/fetchUtil";
import { sliderSpeed } from "../utils/constants";
import LazyReveal from "./LazyReveal";

interface Props {
  title: string,
  bgColor: string
  slug?: string;
  data?: any
}

const Testimonial: React.FC<Props> = ({ title, bgColor, slug, data }) => {
  const sliderRef = useRef<Slider>(null);
  const [testimonialData, setTestimonialData] = useState<any>({})
  const [centerSlide, setCenterSlide] = useState(null);
  const settings = {
    dotsClass: styles.sliderDots,
    dots: false,
    infinite: false,
    speed: sliderSpeed.desktopSpeed,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    initialSlide: 1,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: sliderSpeed.mobileSpeed,
          arrows: false,
          dots: true,
          autoplay: true,
          autoplaySpeed: 200,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: false,
        }
      }
    ]
  };

  useEffect(() => {
    data
      ? setTestimonialData(data)
      : fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/${slug}`, 'GET', {}, '', false)
        .then((res: any) => setTestimonialData(res))
  }, [])

  return (
    testimonialData?.length > 0
      ? <LazyReveal id="studenttestimonial" className={styles.studentTestSlider} style={{ backgroundColor: bgColor }}>
        <Container>
          <Row>
            <h2 className="mb-5 text-center">{title}</h2>
          </Row>
          <div id="studentmm" className={styles.student}>
            <Container>
              <Row>
                <Slider {...settings} ref={sliderRef} className={`${styles.slider}`}>
                  {testimonialData.map((slide: any, ind: number) => {
                    return (ind < 15 &&
                      <div key={ind}>
                        <Card className={`${styles.stuTestCard}`}>
                          <Card.Body className={styles.cardBody}>
                            <svg width="33" height="22" viewBox="0 0 33 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path fillRule="evenodd" clipRule="evenodd" d="M0.0267741 14.2441C0.0232465 14.3384 0.0214669 14.4331 0.0214669 14.5283C0.0214665 18.6548 3.36666 22 7.49316 22C11.6197 22 14.9648 18.6548 14.9648 14.5283C14.9648 10.4018 11.6197 7.05662 7.49316 7.05662C6.73028 7.05662 5.99411 7.17095 5.30084 7.38341C6.8185 4.06918 11.3775 1.11242 13.5805 1.32304e-05C2.06855 2.26919 -0.255979 10.4465 0.0207498 14.2516L0.0267741 14.2441Z" fill="#226CF5" />
                              <path fillRule="evenodd" clipRule="evenodd" d="M18.0492 14.2439C18.0457 14.3382 18.0439 14.4331 18.0439 14.5283C18.0439 18.6548 21.3891 22 25.5156 22C29.6421 22 32.9873 18.6548 32.9873 14.5283C32.9873 10.4018 29.6421 7.05662 25.5156 7.05662C24.7527 7.05662 24.0164 7.17097 23.3231 7.38347C24.8408 4.06924 29.3998 1.11247 31.6028 6.47288e-05C20.0908 2.26924 17.7663 10.4466 18.043 14.2516L18.0492 14.2439Z" fill="#226CF5" />
                            </svg>
                            <p className="my-4">{slide?.testimonial?.message}</p>
                            <h5 className="mb-0">{slide?.testimonial?.name}</h5>
                            <div className={styles.addre}>
                              <span>{slide?.testimonial?.details}</span>
                              <br />
                              <span>{slide?.testimonial?.subDetails}</span>
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                    )
                  })}
                </Slider>
                <div className={styles.arrowsClass}>
                  <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                    <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                  </div>
                  <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                    <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                  </div>
                </div>
              </Row>
            </Container>
          </div>
        </Container>
      </LazyReveal>
      : null
  )
}
export default Testimonial;